var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlCoastalGlobalFathom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    viewBox: "0 0 24 24",
    width: "100%",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 22c0-1.92 0-5.04 7.128-7.92A11.204 11.204 0 0 0 11 13.122V22H2Zm20-11h-8.688c.64-.826 1.108-1.69 1.559-2.523.61-1.127 1.19-2.197 2.123-3.037.833-.75 1.954-.932 3.625-1.205h.001c.423-.07.882-.144 1.38-.235v7Zm-10.215-.374A9.175 9.175 0 0 1 9.61 12.36a9.438 9.438 0 0 0-2.461-.322c-2.424 0-4.14.316-5.149.948v-2.538c.913-.632 2.608-.948 5.083-.948 1.571 0 2.658.34 3.69.733l.56.218.452.175Zm2.086-3.149a27.997 27.997 0 0 1-.892 1.564 25.229 25.229 0 0 1-1.377-.5c-1.294-.498-2.608-1.003-4.453-1.003-2.424 0-4.14.316-5.149.948V5.948C2.913 5.316 4.608 5 7.083 5c1.571 0 2.658.34 3.69.733l.56.218c.868.34 1.751.68 2.91.845a69.78 69.78 0 0 0-.372.681ZM6.058 14.02C3.947 15.105 2.717 16.203 2 17.237v-2.289c.781-.54 2.134-.85 4.058-.928Zm10.435 1.793v.894h1.633v.71h-1.633v1.566h-.817v-3.897h2.877v.726h-2.06ZM22 22V12H12v10h10Zm-9-9h8v8h-8v-8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlCoastalGlobalFathom);
export default __webpack_public_path__ + "static/media/fl_coastal_global_fathom.9e74c521160d94613cdc954254c31b02.svg";
export { ForwardRef as ReactComponent };